if (!customElements.get("delivery-date")) {
  class DeliveryDate extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      this.initDeliveryDates();
    }

    addDays(date, days) {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    monthsByLocale() {
      if (Shopify.locale !== "fr") {
        return ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      }
      return ["Jan","Fév","Mar","Avr","Mai","Jun","Jui","Aout","Sep","Oct","Nov","Déc"];
    }

    formatDate(d) {
      const months = this.monthsByLocale();
      return d.getDate() + " " + months[d.getMonth()];
    }

    parseDateAny(input) {
  if (!input) return null;
  const s = String(input).trim();
  // Try MM/DD/YYYY format by splitting
  const parts = s.split('/');
  if (parts.length === 3 && parts[0].length === 2 && parts[2].length === 4) {
    const mm = parseInt(parts[0], 10) - 1;
    const dd = parseInt(parts[1], 10);
    const yyyy = parseInt(parts[2], 10);
    const d = new Date(yyyy, mm, dd);
    if (!isNaN(d.getTime())) return d;
  }
  const d = new Date(input);
  return isNaN(d.getTime()) ? null : d;
}


    getExpectedDeliveryDate(incomingPoRaw) {
      if (!incomingPoRaw) return null;
      let obj = incomingPoRaw;
      if (typeof incomingPoRaw === "string") {
        const normalized = incomingPoRaw.replace(/&quot;/g, '"');
        try {
          obj = JSON.parse(normalized);
        } catch (e) {
          return null;
        }
      }
      const list = Array.isArray(obj) ? obj : [obj];
      let best = null;
      for (const item of list) {
        const val = item?.ExpectedDeliveryDate || item?.expecteddeliverydate;
        const d = this.parseDateAny(val);
        if (d && (!best || d < best)) best = d;
      }
      return best;
    }

    computeBaseDate(el) {
      const inventoryQty = parseInt(el.getAttribute("data-inventory-qty") || "0", 10);
      let incomingRaw = el.getAttribute("data-incoming-po") || "";
      incomingRaw = incomingRaw.replace(/&quot;/g, '"');
      const expectedDate = this.getExpectedDeliveryDate(incomingRaw);

      if (inventoryQty > 0) return { base: new Date(), from: 5, to: 10 };
      if (expectedDate) return { base: expectedDate, from: 5, to: 10 };
      return { base: new Date(), from: 125, to: 130 };
    }

    renderDeliveryRange(variantId, productId, baseDate, fromOffsetDays, toOffsetDays) {
      const cEl = this.querySelector(".prod_current_date");
      const nEl = this.querySelector(".prod_next_date");
      if (!cEl || !nEl) return;

      const fromDate = this.addDays(baseDate, fromOffsetDays);
      const toDate = this.addDays(baseDate, toOffsetDays);

      cEl.textContent = this.formatDate(fromDate);
      nEl.textContent = this.formatDate(toDate);

      const lineInput = document.querySelector(
        '.line-item-property__field[data-variant-id="' + variantId + '"] #delivery-date'
      );
      if (lineInput) {
        lineInput.value = "Approximate Delivery Date :" + this.formatDate(toDate);
      }
    }

    computeAndRenderForVariant(variantId) {
      const el = this.querySelector('.meta_deliver[data-variant-id="' + variantId + '"]')
        || this.querySelector(".meta_deliver");
      if (!el) return;
      const productId = el.getAttribute("data-product-id");
      const { base, from, to } = this.computeBaseDate(el);
      this.renderDeliveryRange(variantId, productId, base, from, to);
    }

    computeAndRenderEarliest() {
      const els = this.querySelectorAll(".meta_deliver");
      if (!els.length) return;

      let earliestFromDate = null;
      let bestBase = null, bestFrom = 5, bestTo = 10;

      els.forEach((el) => {
        const { base, from, to } = this.computeBaseDate(el);
        const fromDate = this.addDays(base, from);
        if (!earliestFromDate || fromDate < earliestFromDate) {
          earliestFromDate = fromDate;
          bestBase = base;
          bestFrom = from;
          bestTo = to;
        }
      });

      const firstEl = els[0];
      const variantId = firstEl.getAttribute("data-variant-id");
      const productId = firstEl.getAttribute("data-product-id");
      this.renderDeliveryRange(variantId, productId, bestBase, bestFrom, bestTo);
    }

    initDeliveryDates() {
      const els = this.querySelectorAll(".meta_deliver");
      const isProductPage = !!document.querySelector('form[action="/cart/add"]');

      if (isProductPage) {
        const activeEl = this.querySelector('.meta_deliver:not([style*="display:none"])') || els[0];
        if (activeEl) {
          const variantId = activeEl.getAttribute("data-variant-id");
          this.computeAndRenderForVariant(variantId);
        }
      } else {
        this.computeAndRenderEarliest();
      }
    }
  }

  customElements.define("delivery-date", DeliveryDate);
}


